// flow
import { createSelector } from 'reselect';

import { getDatasetsById } from 'data/datasets/selectors';
import { getDatasetId } from 'utils/auth/selectors';

import { SUBSCRIPTIONS_REDUCER_KEY } from './subscriptionsReducer';

export const getSubscriptionsStore = (state) => state[SUBSCRIPTIONS_REDUCER_KEY];

export const isLoading = (state) => getSubscriptionsStore(state).isLoading;
export const loadPending = (state) => getSubscriptionsStore(state).loadPending;
export const getSubscriptions = (state) => getSubscriptionsStore(state).resourcesById;

export const getActiveSubscription = createSelector(
  getSubscriptions,
  getDatasetsById,
  getDatasetId,
  (subscriptionsById, datasetsById, datasetId) => {

    if (subscriptionsById.size > 0 && datasetsById.size > 0 && datasetId) {
      const dataset = datasetsById.get(datasetId);
      if (dataset) {
        return subscriptionsById
          .filter((subscription) => subscription.supportedDatasetPlatforms.contains(dataset.platform))
          .sort((subscription1, subscription2) => subscription1.expireAt.localeCompare(subscription2.expireAt))
          .first();
      }
    }
    return null;
  }
);
